import { ReactifySearchLiquidFactory, Sensors } from "@usereactify/search";
import * as React from "react";
import * as ReactDOM from "react-dom";

import { SearchComp } from "../components/Search/Search";

if (window.location.pathname.startsWith("/search")) {
  const ReactifySearchFactory = new ReactifySearchLiquidFactory({
    mode: "search",
    shopifyPermanentDomain: "remarkable-outdoor-living.myshopify.com",
    includeFields: [
      "title",
      "handle",
      "price",
      "price_min",
      "price_max",
      "vendor",
      "product_type",
      "body_html",
      "published_at",
      "created_at",
      "updated_at",
      "tags",
      "variants.storefrontId",
      "variants.available",
      "variants.title",
      "variants.price",
      "variants.compare_at_price",
      "variants.sku",
      "variants.position",
      "variants.inventory_management",
      "variants.inventory_quantity",
      "variants.inventory_policy",
      "variants.fulfillment_service",
      "variants.option1",
      "variants.option2",
      "variants.option3",
      "variants.image_id",
      "variants.weight",
      "variants.weight_unit",
      "variants.requires_shipping",
      "variants.taxable",
      "variants.barcode",
      "images.src",
      "images.position",
      "images.altText",
      "images.width",
      "images.height",
      "options",
      "options.name",
      "options.position",
      "options.values",
    ],
  });
  const ReactifySearchProvider = ReactifySearchFactory.getProvider();
  const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();
  const ReactifySearchData = ReactifySearchFactory.getData();

  ReactDOM.render(
    <React.StrictMode>
      <ReactifySearchProvider>
        <Sensors />
        <div className="rs__search-results">
          <SearchComp data={{}} colorGroups={ReactifySearchData.colorGroups} />
        </div>
      </ReactifySearchProvider>
    </React.StrictMode>,
    ReactifySearchMountNode
  );
}
